// Mock data for DEA S.R.L. - Motori ed Autoricambi landing page
// NOTE: This is FRONTEND-ONLY mock data. No backend involved yet.

export const company = {
  name: "DEA S.R.L.",
  shortName: "DEA",
  phoneDisplay: "350 921 6759",
  phoneRaw: "3509216759",
  phoneIntl: "+393509216759",
  wa: "393509216759",
  email: "info.dearicambi@gmail.com",
  address: "Via T. Vecellio 271 Mortara (PV)",
  piva: "01425770185",
  hours: "Lun-Ven 09:00-17:00 · Sab 09:00-13:00",
  since: "2010",
  soldPlus: "1.000+",
};

export const engineShowcaseImg =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_dea-autoparts/artifacts/ilv1qy5z_motori.jpg";

export const heroImage =
  "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxlbmdpbmUlMjB3b3Jrc2hvcHxlbnwwfHx8fDE3ODYzNjUyODN8MA&ixlib=rb-4.1.0&q=72&w=1920";

export const offerings = [
  {
    title: "Motori usati",
    text: "Provenienti da veicoli accuratamente selezionati, testati a freddo e dotati di chilometraggio certificato. Garanzia 6-12 mesi.",
    img: "https://images.unsplash.com/photo-1777900201609-ad2f57813ab8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxlbmdpbmUlMjBibG9ja3xlbnwwfHx8fDE3ODYzNjUyODN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Motori rettificati",
    text: "Smontaggio totale, rilavorazione di testata, monoblocco e albero motore, sostituzione componenti usurate. Garanzia 24 mesi.",
    img: "https://images.unsplash.com/photo-1527383418406-f85a3b146499?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxjYXIlMjBlbmdpbmV8ZW58MHx8fHwxNzg2MzY1MjgyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Motori revisionati e rigenerati",
    text: "Pari al nuovo: tutte le parti soggette a usura sostituite, collaudo finale di tenuta e prestazioni. Garanzia 24 mesi.",
    img: "https://images.unsplash.com/photo-1552656967-7a0991a13906?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxlbmdpbmUlMjBibG9ja3xlbnwwfHx8fDE3ODYzNjUyODN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Verifica codice P5",
    text: "Identifichiamo il motore esatto del tuo veicolo tramite codice P5 della carta di circolazione: nessun errore di compatibilità.",
    img: "https://images.pexels.com/photos/8052843/pexels-photo-8052843.jpeg",
  },
];

export const stats = [
  { num: 1000, suffix: "+", label: "Motori venduti" },
  { num: 800, suffix: "+", label: "Clienti soddisfatti" },
  { num: 16, suffix: "", label: "Anni di esperienza", sub: "dal 2010" },
  { num: 35, suffix: "+", label: "Marche trattate" },
  { static: "12-24", label: "Mesi garanzia" },
  { num: 100, suffix: "%", label: "Motori testati", sub: "prima della vendita" },
  { static: "GRATIS", label: "Spedizione", sub: "tutta Italia" },
  { static: "24-48h", label: "Tempi", sub: "di consegna" },
];

export const processSteps = [
  { title: "Richiedi preventivo", text: "Compila il form WhatsApp con marca, modello e codice motore P5. Risposta in giornata." },
  { title: "Ricevi quotazione", text: "Ti inviamo un preventivo dettagliato con prezzo, tempi di consegna e condizioni di garanzia." },
  { title: "Conferma e paga", text: "Bonifico, contanti o pagamento al ritiro. Fattura sempre inclusa, anche per le officine." },
  { title: "Spedizione gratuita", text: "Consegna in 24/48h con corriere espresso, tracking incluso. Garanzia attiva alla consegna." },
];

export const brands = [
  { name: "Abarth", code: "AB" }, { name: "Alfa Romeo", code: "AR" }, { name: "Audi", code: "AU" },
  { name: "BMW", code: "BM" }, { name: "Citroen", code: "CI" }, { name: "Cupra", code: "CU" },
  { name: "DS", code: "DS" }, { name: "Dacia", code: "DA" }, { name: "Fiat", code: "FI" },
  { name: "Ford", code: "FD" }, { name: "Honda", code: "HO" }, { name: "Hyundai", code: "HY" },
  { name: "Jeep", code: "JP" }, { name: "Kia", code: "KI" }, { name: "Lancia", code: "LA" },
  { name: "Land Rover", code: "LR" }, { name: "Lexus", code: "LX" }, { name: "Mazda", code: "MZ" },
  { name: "Mercedes-Benz", code: "MB" }, { name: "Mini", code: "MI" }, { name: "Mitsubishi", code: "MT" },
  { name: "Nissan", code: "NI" }, { name: "Opel", code: "OP" }, { name: "Peugeot", code: "PE" },
  { name: "Porsche", code: "PO" }, { name: "Renault", code: "RE" }, { name: "Seat", code: "SE" },
  { name: "Skoda", code: "SK" }, { name: "Smart", code: "SM" }, { name: "SsangYong", code: "SY" },
  { name: "Subaru", code: "SU" }, { name: "Suzuki", code: "SZ" }, { name: "Tesla", code: "TE" },
  { name: "Toyota", code: "TO" }, { name: "Volkswagen", code: "VW" }, { name: "Volvo", code: "VO" },
];

export const couriers = [
  { name: "BRT", desc: "Corriere espresso", bg: "#e84e0f", fg: "#ffffff" },
  { name: "GLS", desc: "General Logistics", bg: "#1e4d96", fg: "#ffffff" },
  { name: "SDA", desc: "Express Courier", bg: "#ffffff", fg: "#d50032" },
];

export const whyChoose = [
  { title: "16 anni di esperienza", text: "Dal 2010 nel settore. Conosciamo ogni motore, ogni marca, ogni problematica meccanica. La nostra esperienza è il tuo vantaggio.", icon: "star" },
  { title: "35+ marche trattate", text: "Auto, furgoni e veicoli commerciali di tutte le principali case europee e asiatiche. Se non trovi la tua marca, chiedicelo.", icon: "settings" },
  { title: "Garanzia 12-24 mesi", text: "Polizza assicurativa primaria su tutti i motori rettificati e rigenerati. Sai esattamente cosa è coperto e per quanto tempo.", icon: "shield" },
  { title: "Spedizione gratuita Italia", text: "Consegna in 24/48h con corriere espresso, tracking incluso. Spediamo in tutta Italia, isole comprese, senza costi extra.", icon: "truck" },
  { title: "Consulenza tecnica gratuita", text: "Prima dell'acquisto i nostri tecnici ti aiutano a identificare il motore giusto per il tuo veicolo tramite il codice P5.", icon: "help" },
  { title: "Imballaggio rinforzato", text: "Pallet di legno certificato, fissaggio meccanico con cinghie, protezione angolare e film estensibile. Il motore arriva intatto.", icon: "box" },
];

export const reviews = [
  { text: "Motore Fiat Ducato rettificato consegnato in 48h. Imballaggio impeccabile, garanzia scritta inclusa. Funziona perfettamente da 8 mesi. Riacquisterò sicuramente.", name: "Marco R.", role: "Titolare autofficina, Brescia", initial: "M" },
  { text: "Ho cercato a lungo un motore per la mia BMW 320d e qui l'ho trovato a un ottimo prezzo. Consulenza tecnica al telefono molto utile, mi hanno aiutato a verificare il codice P5.", name: "Giorgio P.", role: "Cliente privato, Roma", initial: "G" },
  { text: "Lavoriamo con DEA S.R.L. da anni. Motori sempre testati, garanzia chiara, spedizione rapida. Perfetti per le nostre esigenze di carrozzeria.", name: "Luca M.", role: "Carrozzeria, Napoli", initial: "L" },
  { text: "Avevo bisogno di un motore Audi A4 con poco chilometraggio. Trovato disponibile, spedito gratuitamente in 3 giorni. Tutto come da accordi, motore funzionante senza problemi.", name: "Stefano D.", role: "Cliente privato, Bari", initial: "S" },
  { text: "Servizio professionale dall'inizio alla fine. Mi hanno spiegato la differenza tra motore usato e rettificato e ho potuto scegliere consapevolmente. Garanzia 24 mesi, sono tranquillo.", name: "Andrea F.", role: "Cliente privato, Torino", initial: "A" },
  { text: "Officina convenzionata. Prezzi competitivi e prodotti garantiti. La fattura è sempre puntuale e il rapporto qualità-prezzo è eccellente. Consiglio.", name: "Roberto C.", role: "Officina meccanica, Palermo", initial: "R" },
];

export const engineTypes = [
  { tipo: "usato", nome: "Motore usato garantito", icon: "🔩", desc: "Motore funzionante testato, garanzia 3-12 mesi" },
  { tipo: "revisionato", nome: "Motore revisionato", icon: "⚙️", desc: "Smontato e parti usurate sostituite, garanzia 12-24 mesi" },
  { tipo: "rettificato", nome: "Motore rettificato", icon: "🛠️", desc: "Revisione + lavorazione meccanica, garanzia 12-24 mesi" },
  { tipo: "rigenerato", nome: "Motore rigenerato (km 0)", icon: "🆕", desc: "Componenti in movimento sostituiti con nuovi, garanzia 12-24 mesi" },
];

export const years = Array.from({ length: 37 }, (_, i) => 2026 - i);
